import getEventTotals from './getProcedureEventTotals';
import getEscalatedEvents from './escalated';
import getEventTotalsByStatus from './getEventTotalsByStatus';

export default [getEventTotals, getEscalatedEvents, getEventTotalsByStatus];
